import { render } from "./HealthCenterDetailComponent.vue?vue&type=template&id=eb9d5a44"
import script from "./HealthCenterDetailComponent.vue?vue&type=script&lang=js"
export * from "./HealthCenterDetailComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__